import axios from "axios";
import AlertStore from '@/stores/AlertStore'
import hasPermission from "../filters/hasPermission";
import {
  ENDPOINT_BROUILLON,
  ENDPOINT_EXPORT,
  ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL, ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL_REJECT,
  ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL_VALIDATE,
  ENDPOINT_INIT,
  ENDPOINT_SEARCH
} from "../constants/endpoints";
import {libelles} from "../constants/libelles";

let store = {
  debug: true,

  init(marcheId, trimestreId) {
    return axios
        .get(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + ENDPOINT_INIT, {params: {marcheId, trimestreId}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  getCurrentDraft(marcheId, trimestreId) {
    return axios
        .get(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + ENDPOINT_BROUILLON, {params: {marcheId, trimestreId}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  get(id) {
    return axios
        .get(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + '/' + id)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  create(gpecSynthesePrevisionnel) {
    return axios
        .post(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL, gpecSynthesePrevisionnel)
        .then((response) => {
          let message = response.data.dispense ? libelles.messageCreateFormulaireWithDispense : 'Besoins prévisionnels en recrutements créés avec succès.'
          AlertStore.pushSuccess(message);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  saveDraft(synthese) {
    return axios
        .put(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + ENDPOINT_BROUILLON, synthese)
        .then((value) => {
          return value.data;
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  update(synthese, isDuplicated) {
    return axios
        .put(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL, synthese)
        .then(() => {
          const isAdmin = hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR']);
          const correspondantMsg = "Modification de besoins prévisionnels en recrutements soumise pour approbation.";
          const adminMsg = "Besoins prévisionnels en recrutements modifiés avec succès.";
          const duplicateMsg = "Votre saisie a bien été dupliquée et le formulaire modifié en conséquence";
          const successMessage = isDuplicated ? duplicateMsg : (isAdmin || !synthese.jourSoumissionPassed ? adminMsg : correspondantMsg);
          AlertStore.pushSuccess(successMessage);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  delete(gpecSynthesePrevisionnel) {
    return axios
        .delete(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + '/' + gpecSynthesePrevisionnel.id)
        .then(() => {
          const isAdmin = hasPermission(['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR']);
          const correspondantGpecMsg = "Suppression de besoins prévisionnels en recrutements soumise pour approbation.";
          const adminMsg = "Besoins prévisionnels en recrutements supprimés avec succès.";
          const successMessage = isAdmin || gpecSynthesePrevisionnel.statut === 'ATTENTE_MODIFICATION' || !gpecSynthesePrevisionnel.jourSoumissionPassed ? adminMsg : correspondantGpecMsg;
          AlertStore.pushSuccess(successMessage);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  search(synthese, pageIndex, pageSize, sortOptions) {
    const recherche = this.syntheseToRecherche(synthese);
    let url = `${ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }
    return axios
        .post(url, recherche);
  },

  export(synthese) {
    const recherche = this.syntheseToRecherche(synthese);
    let url = `${ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + ENDPOINT_EXPORT}`;
    return axios
        .post(url, recherche);
  },

  exportById(syntheseId) {
    return axios.get(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + '/' + syntheseId + ENDPOINT_EXPORT);
  },

  validate(synthese) {
    return axios
        .post(ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL_VALIDATE + '/' + synthese.id)
        .then(() => {
          const operation = synthese.statut === 'ATTENTE_MODIFICATION' ? 'modification' : 'suppression';
          AlertStore.pushSuccess(`Demande de ${operation} de besoins prévisionnels en recrutements approuvée avec succès.`);
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  reject(id, commentaire) {
    return axios.post(`${ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL_REJECT}/${id}`, {
      message: commentaire
    })
      .then((response) => {
        if (response.status === 204) {
          AlertStore.pushSuccess('La demande de besoins prévisionnels en recrutements a été rejetée avec succès.')
        }
      }).catch((error) => {
        console.log(error)
        AlertStore.pushError('La demande de besoins prévisionnels en recrutements n\'a pas pu être rejetée.')
      })
  },

  syntheseToRecherche(synthese) {
    let recherche = [];
    recherche.push({key: 'marche', operation: '=', value: synthese.marche});
    recherche.push({key: 'ligne', operation: '=', value: synthese.ligne});
    recherche.push({key: 'statut', operation: '€', value: synthese.statut});
    recherche.push({key: 'trimestre', operation: '=', value: synthese.trimestre});
    recherche.push({key: 'territoire', operation: '=', value: synthese.territoire});
    return recherche;
  }

};

export default store;
